<template lang="pug">
b-table.table-outline.mb-0(hover, responsive, outline, head-variant='default', :items='data', :fields='label', :small='small', @row-clicked='ping', :sort-by.sync="sortBy", :sort-desc.sync="sortDesc")
  // SLOT avatar {Url: String, Status: String, Tooltip: String }
  template(slot='avatar', scope='item')
    div.avatar
      img.img-avatar(:src='item.value.url || "static/img/avatars/0.png"', alt='', v-b-tooltip.hover='userIdString(item.value.tooltip)', v-if='item.value.tooltip')
      span.avatar-status(:class="{ 'bg-success': item.value.status == 'success',  'bg-warning': item.value.status == 'warning', 'bg-danger': item.value.status == 'danger', 'bg-secondary': item.value.status == '' }", v-if='item.value.status')
  // SLOT avatarPlain {Url: String, Status: String, Tooltip: String }
  template(slot='avatarPlain' scope='item')
    div.avatar
      img.img-avatar(:src='item.value.url', alt='')
  // SLOT user {Name: String, New: Boolean, Registered: Boolean, Gender: String}
  template(slot='user', scope='item')
    div
      | {{item.value.name}}&nbsp;
      span(v-if='item.value.gender')
        i.fa.fa-mars.text-primary(v-if='item.value.gender=="male"')
        i.fa.fa-venus.text-danger(v-else)
    div.small.text-muted
      span
        template(v-if="item.value.new")
          | New
        template(v-else) Recurring
      |  | Registered:&nbsp;
      span(v-if='typeof item.value.registered == "number"') {{item.value.registered | moment("from", "now")}}
      span(v-else) {{item.value.registered}}
  // SLOT name [String]
  template(slot='name', scope='item')
    span.text-capitalize {{item.value}}
  // SLOT company {Name: String, Id: String}
  template(slot='company', scope='item')
    div
      | {{item.value.name}}&nbsp;
    div.small.text-muted
      | {{item.value.Id}}
  // SLOT country {Name: String, Flag: String}
  template(slot='country', scope='item')
    img(:src='item.value.flag', :alt='item.value.name', style='height: 24px')
  // SLOT usage
  template(slot='usage', scope='item')
    div.clearfix
      div.float-left
        strong
          | {{item.value.value}}%
      div.float-right
        small.text-muted
          | {{item.value.period}}
    b-progress.progress-xs(v-model='item.value.value', :variant='variant(item.value.value)')
  // SLOT payment [Icon]
  template(slot='payment', scope='item')
    i(:class='item.value.icon', style='font-size:24px')
  // SLOT activity [String]
  template(slot='activity', scope='item')
    div.small.text-muted
      | Last login
    strong
      | {{item.value}}
  // SLOT actions
  template(slot='actions', scope='item')
    b-btn-group
      // BTN Insta Reply (In Popover)
      b-btn.pill-left(type='button', variant='outline-primary', :id='"send"+item.value.id', @click.stop='', v-b-tooltip.hover='"Reply"')
        i.fa.fa-paper-plane-o
      // BTN Chat History
      b-btn(type='button', variant='outline-secondary', :to='chatLink(item.value.id)', router-tag='button' v-b-tooltip.hover='"History"')
        i.fa.fa-history
      // BTN Escalate to BOSS/Supervisor
      //- b-btn(type='button', variant='outline-danger', :to='chatLink(item.value.id)', router-tag='button')
        i.fa.fa-exclamation-triangle
      // BTN Mark as Spam
      //- b-btn(type='button', variant='outline-danger', @click='spam(item.value.id)', v-b-tooltip.hover='"Spam"')
        i.fa.fa-shield
      // BTN Pause Autoreply
      b-btn.pill-right(type='button', variant='danger', v-if='!item.value.paused', @click.stop='pause(item.value.id, item.value.msgID, item.value.timestamp)', v-b-tooltip.hover='"Pause Chatbot"')
        i.fa.fa-pause
      b-btn.pill-right(type='button', variant='success', v-if='item.value.paused', @click.stop='unpause(item.value.id, item.value.msgID, item.value.timestamp)', v-b-tooltip.hover='"Unpause Chatbot"')
        i.fa.fa-play
    // POPOVER Insta Reply
    b-popover(:target='"send"+item.value.id', placement='left', triggers='click', ref='popover')
      b-form(@submit.prevent='sendMessage(item.value.id)', inline, @click.stop='')
        b-form-input.pill-left(type="text", v-model='messageModel[item.value.id]')
        b-btn.btn.pill-right(type='button', @click.stop='sendMessage(item.value.id)', variant='outline-primary', v-b-tooltip.hover='sending ? "Sending Message" : "Send Message"', :disabled='!messageModel[item.value.id]')
          i.fa.fa-refresh.fa-spin(v-if='sending')
          i.icon-paper-plane(v-else)
  // SLOT quicksend
  template(slot='quicksend', scope='item')
    b-form(@submit.prevent='sendMessage(item.value.id, true)', inline,  @click.stop='')
      b-input-group.ml-auto
        b-form-input(v-model='messageModel[item.value.id]')
        b-input-group-button(slot='right')
          b-button.btn(type='button', variant='danger', v-if='!item.value.paused', @click='pause(item.value.id, item.value.msgID, item.value.timestamp)', v-b-tooltip.hover='"Pause Chatbot"')
            i.fa.fa-pause
          b-button.btn(type='button', variant='success', v-if='item.value.paused', @click='unpauseResolve(item.value.id, item.value.msgID, item.value.timestamp, true)', v-b-tooltip.hover='"Unpause Chatbot"')
            i.fa.fa-play
          // BTN Mark as Spam
          b-btn(type='button', variant='outline-danger', @click='spam(item.value.id, item.value.msgID, item.value.timestamp, true)', v-b-tooltip.hover='"Spam"')
            i.fa.fa-shield
          b-button.btn.text-white(type='submit', variant='secondary', @click.stop='sendMessage(item.value.id, true)', v-b-tooltip.hover='sending ? "Sending Message" : "Send Message"', :disabled='!messageModel[item.value.id]')
            i.fa.fa-refresh.fa-spin(v-if='sending')
            i.icon-paper-plane(v-else)
    //- b-btn-group
      b-form(@submit='sendMessage', inline)
        b-form-input.pill-left(type="text", v-model='msg')
        b-btn.btn.pill-right(type='button', @click='sendMessage(item.value.id)', variant='outline-primary')
          i.icon-refresh(v-if='sending')
          i.icon-paper-plane(v-else)
      // BTN Pause Autoreply
      b-btn.pill-right(type='button', variant='danger', v-if='!item.value.paused', @click.stop='pause(item.value.id, item.value.msgID, item.value.timestamp)')
        i.fa.fa-pause
      b-btn.pill-right(type='button', variant='success', v-if='item.value.paused', @click.stop='unpause(item.value.id, item.value.msgID, item.value.timestamp)')
        i.fa.fa-play
  // SLOT timestamp [String]
  template(slot='timestamp', scope='item')
    | {{item.value | moment("from", "now")}}
  // SLOT momentDate [String]
  template(slot='momentDate', scope='item')
    | {{item.value | moment("from", "now")}}
  // SLOT numTimestamp [String]
  template(slot='numTimestamp', scope='item')
    | {{item.value | moment("Do MMM 'YY, hh:mmA")}}
  // SLOT timezone [String]
  template(slot='timezone', scope='item')
    | +{{item.value}}
  // SLOT message [String]
  template(slot='message', scope='item')
    div {{item.value}}
  // SLOT messagePair [String, String]
  template(slot='messagePair', scope='item')
    div.text-secondary {{item.value.messagePrev}}
    div {{item.value.message}}
  // SLOT upperCase [String]
  template(slot='upperCase', scope='item')
    | {{item.value | upperCase}}
  // SLOT NRIC [Int]
  template(slot='nric', scope='item')
    | {{item.value | nric}}
  // SLOT messageID [String]
  template(slot='messageId', scope='item')
    | {{item.value}}
  // SLOT facebookMessengerID [String]
  template(slot='fbId', scope='item')
    | {{item.value}}
  // SLOT phoneID [String]
  template(slot='phoneId', scope='item')
    | {{item.value}}
  // SLOT topic [String]
  template(slot='topic', scope='item')
    | {{item.value | cleanTime}}
  // SLOT intent [String]
  template(slot='intent', scope='item')
    | {{item.value}}
  // SLOT users [String]
  template(slot='users', scope='item')
    | {{item.value}}
  // SLOT interactions [String]
  template(slot='interactions', scope='item')
    | {{item.value}}
  // SLOT exits [String]
  template(slot='exits', scope='item')
    | {{item.value}}
    small %
  // SLOT respondTime [String]
  template(slot='respondTime', scope='item')
    | {{item.value}}
    small s
  // SLOT agent {Url: String, Status: String, Tooltip: String }
  template(slot='agent' scope='item')
    div.avatar
      img.img-avatar(:src='item.value.url', alt='', v-b-tooltip.hover.right='userIdString(item.value.tooltip)')
      //- span.avatar-status(:class="{ 'bg-success': item.value.status == 'success',  'bg-warning': item.value.status == 'warning', 'bg-danger': item.value.status == 'danger', 'bg-secondary': item.value.status == '' }")
  // SLOT campaign [String]
  template(slot='campaign', scope='item')
    div(v-if='item.value.campaignTitle')
      | {{item.value.campaignTitle}}
    div(v-else)
      | Untitled Campaign
    div.small.text-muted
      | {{item.value.campaign}}
    // might add filter for text that's too long
  // SLOT startDate [Date as String]
  template(slot='startDate', scope='item')
    | {{item.value}}
  // SLOT endDate [Date as String]
  template(slot='endDate', scope='item')
    | {{item.value}}
  // SLOT audience [String]
  template(slot='audience', scope='item')
    | {{item.value}}
  // SLOT status [Boolean]
  template(slot='sent', scope='item')
    i.fa.fa-check.text-success(v-if='item.value')
    i.fa.fa-spinner(v-else)
  // SLOT statusString [String]
  template(slot='statusString', scope='item')
    b-btn.mr-1.text-white(type='button', variant='secondary', :href='item.value.mapUrl', target='_blank', :disabled='!item.value.mapUrl' v-if='item.value.mapUrl != "null"')
      i.fa.fa-map-marker
    b-btn.mr-1(type='button', variant='primary', :href='item.value.formUrl', target='_blank', :disabled='!item.value.formUrl' v-if='item.value.formUrl != "null"')
      i.fa.fa-file-o
    b-btn.mr-1(type='button', variant='primary', :href='item.value.imageUrl', target='_blank', :disabled='!item.value.imageUrl' v-if='item.value.imageUrl != "null"')
      i.fa.fa-file-image-o
    b-btn.mr-1.text-white(type='button', variant='secondary', :href='item.value.carUrl', target='_blank', :disabled='!item.value.carUrl' v-if='item.value.carUrl != "null"')
      i.fa.fa-car
    b-btn.mr-1(type='button', variant='success' v-if='item.value.btn1=="Followed Up" && !item.value.resolved', @click='resolved(item.value.id, item.value.crm, item.value.resolved)')
      | Mark as Done
    b-btn.mr-1(type='button', variant='outline-success' v-else-if='item.value.btn1=="Followed Up" && item.value.resolved && item.value.userAccessLevel=="agent"', @click='resolved(item.value.id, item.value.crm, item.value.resolved)' disabled)
      | Done
    b-btn.mr-1(type='button', variant='outline-success' v-else-if='item.value.btn1=="Followed Up" && item.value.resolved', @click='resolved(item.value.id, item.value.crm, item.value.resolved)')
      | Mark as Undone
    b-btn.mr-1(type='button', variant='success' v-else-if='item.value.btn1')
      | {{item.value.btn1}}
    b-btn.mr-1(type='button', variant='success' v-else-if='item.value.btn1')
      | Qualify
    b-btn.mr-1(type='button', variant='success', :id='"remark"+item.value.id', @click.stop='', v-if='item.value.remark == null || item.value.remark == ""')
      | Make Remark
    b-btn.mr-1(type='button', variant='outline-success', v-else, @click.stop='', :id='"viewRemark"+item.value.id')
      | View Remark
    //- b-modal(title='Remark', size='lg', v-model='modalAppear[item.value.id]')
      b-form(@submit='sendRemark')
        b-form-input(v-modal='remark' placeholder='Enter remark')
      div(slot='modal-footer')
        b-button(type='submit' @click='sendRemark(item.value.id)') Submit
    b-popover(:target='"remark"+item.value.id', placement='left', triggers='click', ref='popover', v-if='item.value.remark == null || item.value.remark == ""')
      b-form(@submit='sendRemark', inline)
        b-form-input.pill-left(type="text", v-model='messageModel[item.value.id]')
        b-btn.btn.pill-right(type='button', @click='sendRemark(item.value.id, item.value.crm, messageModel[item.value.id])', variant='success', v-b-tooltip.hover='sending ? "Sending Remark" : "Send Remark"')
          i.fa.fa-refresh.fa-spin(v-if='sending')
          i.fa.fa-chevron-right(v-else)
    b-popover(:target='"viewRemark"+item.value.id', placement='left', triggers='click', ref='popover', v-else)
      b-form-input(type="text", v-model='item.value.remark' readonly)
  // SLOT approval [Boolean]
  template(slot='approval', scope='item')
    i.fa.fa-check.text-success(v-if='item.value=="approved"')
    i.fa.fa-spinner(v-else-if='item.value=="pending"')
    i.fa.fa-times.text-danger(v-else)
  // SLOT platform [Date as String]
  template(slot='platform', scope='item')
    // if yes show green else grey
    b-row
      b-col(v-b-tooltip.hover='"Email"')
        i.fa.fa-envelope-o(:class='{"text-success": item.value.email}')
      b-col(v-b-tooltip.hover='"SMS"')
        i.fa.fa-mobile(:class='{"text-success": item.value.sms}')
      b-col(v-b-tooltip.hover='"Facebook Messenger"')
        i.fa.fa-facebook(:class='{"text-success": item.value.messenger}')
  // SLOT actions
  template(slot='broadcastActions', scope='item')
    // BTN open
    router-link(:to='broadcastLink(item.value)')
      b-btn.mr-1(type='button', variant='outline-secondary')
        i.fa.fa-chevron-right
  // SLOT loanAmount [String]
  template(slot='loanAmount', scope='item')
    div
      | RM {{item.value}}
  // SLOT turnOverAmount [String]
  template(slot='turnOverAmount', scope='item')
    div
      | RM {{item.value}}
  // SLOT influence [Boolean]
  template(slot='influence', scope='item')
    i.fa(:class='["fa-users", "text-"+influence(item.value)]')
    |  {{item.value}}
  template(slot='manualRate', scope='item')
    input(type="checkbox" class='checkbox' @click="checkboxToggle(item.value.key)")
  template(slot='reason', scope='item')
    div( v-b-tooltip.hover='item.value')
      | {{item.value}}
</template>
<script>
import { send, cancelCountdown } from '@/api'
import { db } from '@/firebase'

const usersRef = db.ref('users')
const msgsRef = db.ref('newestChats')
const flagRef = db.ref('flags')
const customRef = db.ref('custom')

export default {
  name: 'app-table',
  data: function() {
    return {
      messageModel: {},
      modalAppear: {},
      remark: null,
    }
  },
  props: {
    sortBy: null,
    sortDesc: true,
    loading: true,
    small: false, // compact table
    rowClick: false,
    rowBroadcastClick: false,
    sending: false,
    msg: null,
    data: {
      type: Array,
      default: () => [
        {
          avatar: { url: 'static/img/avatars/1.jpg', status: 'success' },
          user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2017' },
          country: { name: 'USA', flag: 'static/img/flags/USA.png' },
          usage: { value: 50, period: 'Jun 11, 2017 - Jul 10, 2017' },
          payment: { name: 'Mastercard', icon: 'fa fa-cc-mastercard' },
          activity: '10 sec ago',
          actions: { name: 'Yiorgos Avraamu' },
        },
        {
          avatar: { url: 'static/img/avatars/2.jpg', status: 'danger' },
          user: { name: 'Avram Tarasios', new: false, registered: 'Jan 1, 2017' },
          country: { name: 'Brazil', flag: 'static/img/flags/Brazil.png' },
          usage: { value: 22, period: 'Jun 11, 2017 - Jul 10, 2017' },
          payment: { name: 'Visa', icon: 'fa fa-cc-visa' },
          activity: '5 minutes ago',
          actions: { name: 'Yiorgos Avraamu' },
        },
        {
          avatar: { url: 'static/img/avatars/3.jpg', status: 'warning' },
          user: { name: 'Quintin Ed', new: true, registered: 'Jan 1, 2017' },
          country: { name: 'India', flag: 'static/img/flags/India.png' },
          usage: { value: 74, period: 'Jun 11, 2017 - Jul 10, 2017' },
          payment: { name: 'Stripe', icon: 'fa fa-cc-stripe' },
          activity: '1 hour ago',
          actions: { name: 'Yiorgos Avraamu' },
        },
        {
          avatar: { url: 'static/img/avatars/4.jpg', status: '' },
          user: { name: 'Enéas Kwadwo', new: true, registered: 'Jan 1, 2017' },
          country: { name: 'France', flag: 'static/img/flags/France.png' },
          usage: { value: 98, period: 'Jun 11, 2017 - Jul 10, 2017' },
          payment: { name: 'PayPal', icon: 'fa fa-paypal' },
          activity: 'Last month',
          actions: { name: 'Yiorgos Avraamu' },
        },
        {
          avatar: { url: 'static/img/avatars/5.jpg', status: 'success' },
          user: { name: 'Agapetus Tadeáš', new: true, registered: 'Jan 1, 2017' },
          country: { name: 'Spain', flag: 'static/img/flags/Spain.png' },
          usage: { value: 22, period: 'Jun 11, 2017 - Jul 10, 2017' },
          payment: { name: 'Google Wallet', icon: 'fa fa-google-wallet' },
          activity: 'Last week',
          actions: { name: 'Yiorgos Avraamu' },
        },
        {
          avatar: { url: 'static/img/avatars/6.jpg', status: 'danger' },
          user: { name: 'Friderik Dávid', new: true, registered: 'Jan 1, 2017' },
          country: { name: 'Poland', flag: 'static/img/flags/Poland.png' },
          usage: { value: 43, period: 'Jun 11, 2017 - Jul 10, 2017' },
          payment: { name: 'Amex', icon: 'fa fa-cc-amex' },
          activity: 'Last week',
          actions: { name: 'Yiorgos Avraamu' },
        },
      ],
    },
    label: {
      type: Object,
      default: () => {
        return {
          avatar: {
            label: '<i class="icon-people"></i>',
            class: 'text-center',
          },
          user: {
            label: 'User',
          },
          country: {
            label: 'Country',
            class: 'text-center',
          },
          usage: {
            label: 'Usage',
          },
          payment: {
            label: 'Payment method',
            class: 'text-center',
          },
          activity: {
            label: 'Activity',
          },
          actions: {
            label: '',
            thStyle: {
              minWidth: '14em',
            },
          },
        }
      },
    },
  },
  computed: {
  },
  updated: function() {
    const that = this
    if (typeof that.data[0] != 'undefined') {
      let checkboxArray = document.getElementsByClassName('checkbox')
      for (let i = 0; i < that.data.length; i++) {
        let id = 'checkbox' + that.data[i].manualRate.key
        checkboxArray[i].id = id
        checkboxArray[i].checked = that.data[i].manualRate.value
      }
    }
  },
  methods: {
    checkboxToggle(value) {
      let id = 'checkbox' + value
      let bool = {
        manualRate: document.getElementById(id).checked,
      }
      customRef.child('jobRequirement').child(value).update(bool)
    },
    letModalAppear(id) {
      this.modalAppear[id] = true
      console.log(this.modalAppear)
    },
    ping (e) {
      this.rowClick && this.$router.push({ name: 'Interaction', params: { userId: e.userId } })
      this.rowBroadcastClick && this.$router.push({ name: 'Broadcast', params: { Id: e.broadcastActions } })
    },
    sendMessage(userId, flagged) {
      this.sending = true
      var content = {
        platform: 'webPopup',
        userID: userId,
        message: this.messageModel[userId],
      }
      console.log(content)
      send(content)
        .then(function (res) {
          res.error && this.$snotify.error(res.error)
          this.sending = false
          this.messageModel[userId] = ''
          // if flagged, cancel countdown
          flagged && cancelCountdown(userId).then(function (res) { console.log(res) })
        }.bind(this))
      // this.$refs.popover.$emit('close')
      this.$root.$emit('bv::hide::popover')
    },
    sendRemark (id, crm, remark) {
      customRef.child(crm).child(id).update({
        remark: remark,
      })
      this.$root.$emit('bv::hide::popover')
    },
    onClose() {
      // Emitting 'close' on the popover will trigger it to hide for us
      this.$refs.popover.$emit('close')
    },
    // User Chat Link
    chatLink (value) {
      return { name: 'Interaction', params: { userId: value } }
    },
    // Broadcast Link
    broadcastLink (value) {
      return { path: '/broadcast/' + value }
    },
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    influence (value) {
      let $influence
      if (value < 300) {
        $influence = 'danger'
      } else if (value >= 300 && value < 1000) {
        $influence = 'warning'
      } else if (value >= 1000 && value < 10000) {
        $influence = 'success'
      } else if (value >= 10000) {
        $influence = 'info'
      }
      return $influence
    },
    heat (value) {
      let $heat
      if (value < 300) {
        $heat = 1
      } else if (value >= 300 && value < 1000) {
        $heat = 2
      } else if (value >= 1000 && value < 10000) {
        $heat = 3
      } else if (value >= 10000) {
        $heat = 4
      }
      return $heat
    },
    userIdString (value) {
      return value ? value.toString() : ''
    },
    mailTo (email) {
      return 'mailto:' + email
    },
    pause (userId, msgId, timestamp) {
      usersRef.child(userId).update({
        takeover: true,
      })
      /* var content = {
        platform: 'webPopup',
        userID: userId,
        message: 'A live agent just joined the chat'
      }
      console.log(content)
      send(content)
        .then(function (res) {
          res.error && this.$snotify.error(res.error)
          this.sending = false
        }.bind(this)) */
      msgsRef.child(msgId).update({
        // to trigger Chats event
        timestamp: timestamp + 1,
      })
      console.log(userId, msgId, 'paused')
    },
    unpause (userId, msgId, timestamp) {
      usersRef.child(userId).update({
        takeover: false,
      })
      /* var content = {
        platform: 'webPopup',
        userID: userId,
        message: 'A live agent just left the chat'
      }
      console.log(content)
      send(content)
        .then(function (res) {
          res.error && this.$snotify.error(res.error)
          this.sending = false
        }.bind(this)) */
      msgsRef.child(msgId).update({
        // to trigger Chats event
        timestamp: timestamp - 1,
      })
      console.log(userId, msgId, 'unpaused')
    },
    unpauseResolve (userId, msgId, timestamp, flagged) {
      usersRef.child(userId).update({
        takeover: false,
      })
      flagRef.orderByChild('userID').equalTo(userId).on('value', function(snapshot) {
        Object.entries(snapshot.val()).forEach(
          function([key, val]) {
            flagRef.child(key).remove()
          })
      })
      // if flagged, cancel countdown
      flagged && cancelCountdown(userId).then(function (res) { console.log(res) })
      msgsRef.child(msgId).update({
        // to trigger Chats event
        timestamp: timestamp - 1,
      })
      console.log(userId, msgId, 'unpaused')
    },
    spam (userId, msgId, timestamp, flagged) {
      flagRef.orderByChild('userID').equalTo(userId).on('value', function(snapshot) {
        Object.entries(snapshot.val()).forEach(
          function([key, val]) {
            flagRef.child(key).remove()
          })
      })
      usersRef.child(userId).update({
        takeover: false,
      })
      // if flagged, cancel countdown
      flagged && cancelCountdown(userId).then(function (res) { console.log(res) })
      msgsRef.child(msgId).update({
        // to trigger Chats event
        timestamp: timestamp - 1,
      })
    },
    resolved (key, crm, resolved) {
      customRef.child(crm).child(key).update({ resolved: !resolved })
    },
  },
  filters: {
    cleanTime (val) {
      return val.slice(0, -3)
    },
    nric (val) {
      try {
        val = val.toString()
        if (val.length == 12) {
          var arr = val.split('')
          arr.splice(6, 0, '-')
          arr.splice(9, 0, '-')
          val = arr.join('')
        }
        return val
      } catch (res) {
        console.log('nric', res)
        return 'Not Available'
      }
    },
    upperCase (val) {
      if (val) {
        var str = ''
        for (var i in val) {
          if (!parseInt(val[i])) {
            str += val[i].toUpperCase()
          } else {
            str += val[i]
          }
        }
        return str
      } else {
        return val
      }
    },
    camelCase (val) {
      return val.split(' ').map(function(word, index) {
        // If it is not the first word only upper case the first char and lowercase the rest.
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      }).join(' ')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Table.vue?61b65c4b